"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapBreakpoints = void 0;
var mapBreakpoints = function mapBreakpoints(breakpoints) {
  var mappedBreakpoints = {};
  Object.keys(breakpoints).sort(function (a, b) {
    return breakpoints[a] - breakpoints[b];
  }).forEach(function (key) {
    var value = breakpoints[key];
    mappedBreakpoints["screen >= $".concat(key)] = "(min-width: ".concat(value, "px)");
    if (value > 0) {
      mappedBreakpoints["screen < $".concat(key)] = "(max-width: ".concat(value - 1, "px)");
    }
  });
  return mappedBreakpoints;
};
exports.mapBreakpoints = mapBreakpoints;